import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 链动 #10027
export default [{
  path: "/chaining_new",
  component: function component() {
    return import("../../../views/extension/chaining_new/index.vue");
  },
  name: "chaining_new",
  meta: {
    title: "新店商",
    foot: true
  }
}];